class ProductParamsVA {
    constructor({
        visattractiontype,
        visattrntemporperm,
        visattrnseasonal,
        visattrnstdticketcost,
        visattrnage,
        visattrncountry,
        visattrncity,
    }) {
        this.visattractiontype = visattractiontype
        this.visattrntemporperm = visattrntemporperm
        this.visattrnseasonal = visattrnseasonal
        this.visattrnstdticketcost = visattrnstdticketcost
        this.visattrnage = visattrnage
        this.visattrncountry = visattrncountry
        this.visattrncity = visattrncity
    }

    toJSON = () => ({
        visattractiontype: this.visattractiontype,
        visattrntemporperm: this.visattrntemporperm,
        visattrnseasonal: this.visattrnseasonal,
        visattrnstdticketcost: this.visattrnstdticketcost,
        visattrnage: this.visattrnage,
        visattrncountry: this.visattrncountry,
        visattrncity: this.visattrncity,
    })
}

export default ProductParamsVA
